import { render, staticRenderFns } from "./s2.vue?vue&type=template&id=0f51af42&"
import script from "./s2.vue?vue&type=script&lang=js&"
export * from "./s2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports